const type = 'CLOSE_NEW_CARD_CONFIRMATION';

const closeNewCardConfirmation = () => ({
  type,
});

export { type };
export default closeNewCardConfirmation;
